<template>
  <div>
    <!-- <ion-header>
      <ion-toolbar class="rc-tool-bar">
        <ion-title>{{ title }}</ion-title>
      </ion-toolbar>
    </ion-header> -->
    <ion-content class="ion-padding stop-repeating-content">
      <div class="page">
        <ion-grid>
          <ion-row class="rectangle">
            <ion-col>
              <p>{{ title }}</p>
            </ion-col>
          </ion-row>
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle">
            <ion-col size="12" size-md="12" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Reason
                <span class="required">*</span>
              </ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="reason"
                  @ionChange="reason = $event.target.value"
                  placeholder="Select Cancel Reason"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(reason, index) in this.reasons"
                    :key="index"
                    :value="reason.id"
                  >{{reason.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="reason"
                  placeholder="Select Cancel Reason"
                >
                  <option
                    v-for="(reason, index) in this.reasons"
                    :key="index"
                    :value="reason.id"
                  >{{reason.name}}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="12" class="col-padding">
              <ion-label class="section-item" position="stacked">Others</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  placeholder="Enter Other Reason"
                  @input="otherReason = $event.target.value"
                  :value="otherReason"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-button class="btn-primary" expand="block" @click="this.validateReason">Yes</ion-button>
            </ion-col>
            <ion-col>
              <ion-button class="btn-secondary" expand="block" @click="this.dismissDialog">No</ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonTitle, IonContent, IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, modalController } from "@ionic/vue";

import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { ToastUtils } from "../../util/toast-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
  name: "ReservationCancellationModal",
  components: {
    IonHeader, 
    IonToolbar, 
    IonTitle, 
    IonContent, 
    IonGrid, 
    IonRow, 
    IonCol, 
    IonLabel, 
    IonSelect, 
    IonSelectOption, 
    IonInput, 
    IonButton,
    modalController
  },
  props: {
    title: { type: String, default: "Reservation Cancellation" },
  },
  async mounted() {
    try {
      this.reasons = await new EVCStationReservationService().reservationCancelReasons();
    } catch(error) {
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
  },
  data() {
    return {
      reason: "",
      otherReason: "",
      reasons: []
    }
  },
  methods: {
    validateReason() {
      if (
        typeof this.reason === "undefined" ||
        this.reason === null ||
        this.reason === ""
      ) {
        new ToastUtils().presentToast("Select Cancel Reason");
      } else if (
        this.reason === "OTHER" &&
        (this.otherReason === null ||
          this.otherReason === "" ||
          this.otherReason.trim().length === 0)
      ) {
        new ToastUtils().presentToast("Enter Other Reason");
      } else {
        // this.cancelBooking(this.reason, this.otherReason);
        
        modalController.dismiss(this.reason, this.otherReason)
      }
    },
    dismissDialog() {
      modalController.dismiss()
    }
  },
})
</script>

<style scoped>
.rc-tool-bar {
  background-color: blue;
} 
.stop-repeating-content {
  position: absolute;
  /* height: 450px; */
}

ion-modal {
 --width: 80% !important; 
 --hight: 80% !important;
}
</style>